import script from "./ComHuonekorttiValinta.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComHuonekorttiValinta.vue?vue&type=script&setup=true&lang=ts"

import "./ComHuonekorttiValinta.vue?vue&type=style&index=0&id=63a93abe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a93abe"]])

export default __exports__